var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransferCashBb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 13.676 0 8.514 2.767 4.983a13 13 0 0 1 2.216-2.216C8.514 0 13.676 0 24 0s15.486 0 19.017 2.767c.826.646 1.57 1.39 2.216 2.216C48 8.514 48 13.676 48 24s0 15.486-2.767 19.017c-.646.826-1.39 1.57-2.216 2.216C39.486 48 34.324 48 24 48S8.514 48 4.983 45.233a12.998 12.998 0 0 1-2.216-2.216C0 39.486 0 34.324 0 24Z",
    fill: "#F3F3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.313 15.082H13.686c-1.16 0-2.062.945-2.062 2.063V32.27c0 1.16.902 2.062 2.063 2.062h20.624a2.063 2.063 0 0 0 2.063-2.063V17.145c0-1.118-.945-2.063-2.063-2.063ZM35 32.27a.707.707 0 0 1-.688.687H13.689a.679.679 0 0 1-.688-.688V17.145c0-.344.3-.688.688-.688h20.624c.344 0 .688.344.688.688V32.27Zm-15.125-2.922c0-.258-.258-.516-.516-.516h-3.093c-.301 0-.516.258-.516.516v.343c0 .301.215.516.516.516h3.093a.522.522 0 0 0 .516-.516v-.343Zm8.25 0c0-.258-.258-.516-.516-.516h-5.843c-.301 0-.516.258-.516.516v.343c0 .301.215.516.516.516h5.843a.522.522 0 0 0 .516-.516v-.343Z",
    fill: "#EC3342"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransferCashBb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transfer-cash-bb.ff4f114f4ed67f2514cf245b3f18e367.svg";